import { Select, TextField } from '@mui/material';
import { height, margin, styled } from '@mui/system';
import moment from 'moment';

export const formatTime = (e: any) => {
  return moment(e).isValid() ? moment(e).format('yyyy-MM-DD') : null;
};

export const keyDownOnlyNumber = (input: any) => {
  if (
    ((input.keyCode < 48 && input.keyCode !== 8) || input.keyCode > 57) &&
    !input.ctrlKey &&
    !input.metaKey
  ) {
    input.preventDefault();
  }
};

// use for AutocompleteInput and DatePicker components
export const CssTextField = styled(TextField)({
  '&': {
    display: 'block',
    width: '100%',
    backgroundColor: 'white',
  },
  '& label': {
    display: 'none',
  },
  '& fieldset': { 
    top: 0,
    borderWidth: '1px !important',
    userSelect: 'all',
    borderColor: 'rgb(205, 215, 225)',
  },
  '& .MuiTextField-root': {
      borderColor: 'rgb(205, 215, 225)',
  },
  '& .MuiOutlinedInput-root': {
    width: '100%',
    height: '48px',
    boxShadow: 'rgb(0, 0, 0) 0px 0px 0px 0px, rgba(21, 21, 21, 0.08) 0px 1px 2px 0px', 
    borderRadius: '6px',
    '& input': {
      padding: '0 0 0 12px!important',
      margin: 0,
      fontSize: '16px',
    },
    '&:hover fieldset': {
      borderColor: 'rgba(0, 0, 0, 0.23)',
    },
    '& fieldset legend': {
      userSelect: 'none',
    }
  },
  '& .MuiOutlinedInput-root.Mui-focused fieldset': {
    borderColor: 'rgb(11, 107, 203)', //'#8894aa',
    borderWidth: '2px !important',
    border: '2px solid rgb(11, 107, 203)',
    margin: '-1px',
    boxShadow: 'rgb(11, 107, 203) 0px 0px 0px 0px inset',
    top: 0,
  },
  '& .MuiOutlinedInput-root.Mui-disabled fieldset': {
    borderColor: 'rgb(205, 215, 225)',
  },
  '& .MuiOutlinedInput-input.MuiInputBase-input.MuiAutocomplete-input':{
    height: 'inherit',
  },
  '& .MuiOutlinedInput-root.MuiInputBase-root.MuiInputBase-formControl': {
    height: 'max-content',
    minHeight: '48px',
    paddingBottom: '0',
  },
  '& .MuiAutocomplete-tag': {
    margin: '9px 2px',
  }
});


export const CssSelect = styled(Select)({
  '&': {
    display: 'block',
    width: '100%',
    borderColor: '#8A93A8',
    height: '43px',
    borderRadius: '.5rem',
    background: 'white',
    paddingTop: '2px!important',
    color: '#0c2551 !important',
    '& .MuiSelect-select': {
      maxWidth: 'calc(100% - 46px)',
      paddingTop: '8px',
      fontSize: '16px',
      fontWeight: '500',
    },

    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#8A93A8 !important',
      borderWidth: '1px !important',
      top: '-2px',
    },
    '&:hover fieldset': {
      borderColor: '#8A93A8',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#8A93A8',
    },
  },
});
